import "core-js/modules/es6.function.name";

/* eslint-disable react/jsx-indent */
import dstyled from 'astroturf';
import React from 'react';
import ComponentImport from './ComponentImport';
import Example from './Example';
import HookSignature from './HookSignature';
import LinkedHeading from './LinkedHeading';
import OutlineHeading from './OutlineHeading';
import PageLayout from './PageLayout';
var SignatureList = /*#__PURE__*/dstyled('ul', null, {
  displayName: "SignatureList",
  styles: require("./HookPage-SignatureList.module.css"),
  attrs: null,
  vars: []
});

function HookPage(_ref) {
  var data = _ref.data;
  var _data$docpocalypse = data.docpocalypse,
      signatures = _data$docpocalypse.signatures,
      tsType = _data$docpocalypse.tsType,
      name = _data$docpocalypse.name,
      importName = _data$docpocalypse.importName,
      example = _data$docpocalypse.example;
  return /*#__PURE__*/React.createElement(PageLayout, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OutlineHeading, {
    h: 1,
    id: name + "-page",
    title: name
  }, name)), /*#__PURE__*/React.createElement(Example, {
    example: example,
    name: name
  }), /*#__PURE__*/React.createElement(LinkedHeading, {
    h: 2,
    id: name + "-api"
  }, "API"), importName && /*#__PURE__*/React.createElement(ComponentImport, {
    importName: importName,
    docNode: data.docpocalypse
  }), /*#__PURE__*/React.createElement(SignatureList, null, (tsType === null || tsType === void 0 ? void 0 : tsType.signatures) ? tsType === null || tsType === void 0 ? void 0 : tsType.signatures.map(function (doc) {
    return /*#__PURE__*/React.createElement(HookSignature, {
      level: 3,
      tsDocType: doc
    });
  }) : signatures === null || signatures === void 0 ? void 0 : signatures.map(function (doc) {
    return /*#__PURE__*/React.createElement(HookSignature, {
      level: 3,
      jsDocType: doc
    });
  })));
}

export default HookPage;